import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { fmtArgent } from '@/lib/lmdsDeductions';
import { LIBELLES_STATUT, CLASSES_STATUT } from '@/components/lmds/CartesPerformance';

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')}` } });
const fmt0 = (v) => new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 }).format(v || 0);

// 🧾 Phase 4B : tableau de gestion — tous les installateurs (réalisé / % / projection / statut / rang).
export function TableauPerformance({ rafraichir }) {
  const [annee, setAnnee] = useState(new Date().getFullYear());
  const [data, setData] = useState(null);
  const charger = useCallback(async () => {
    const r = await axios.get(`${API}/api/installateurs/performance?annee=${annee}`, auth());
    setData(r.data);
  }, [annee]);
  useEffect(() => { charger().catch(() => toast.error('Impossible de charger la performance.')); }, [charger, rafraichir]);
  return (
    <Card data-testid="tableau-performance">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-base">Performance {annee}{data ? ` — objectif ${fmt0(data.objectif)}` : ''}</CardTitle>
        <input type="number" className="border rounded-md h-9 px-2 text-sm w-24" value={annee} onChange={(e) => setAnnee(parseInt(e.target.value) || annee)} data-testid="performance-filtre-annee" />
      </CardHeader>
      <CardContent className="overflow-x-auto">
        {!data ? <p className="text-sm text-slate-500">Chargement…</p> : !data.installateurs.length ? <p className="text-sm text-slate-500" data-testid="performance-vide">Aucun installateur.</p> : (
          <table className="w-full text-sm" data-testid="table-performance">
            <thead className="text-xs text-slate-500 text-left">
              <tr><th className="p-2">Rang</th><th className="p-2">Installateur</th><th className="p-2 text-right">Réalisé</th><th className="p-2 text-right">%</th><th className="p-2 text-right">Rythme / sem</th><th className="p-2 text-right">Projection</th><th className="p-2">Statut</th></tr>
            </thead>
            <tbody>
              {data.installateurs.map((l) => (
                <tr key={l.installateur_id} className="border-t" data-testid={`performance-${l.installateur_id}`}>
                  <td className="p-2 font-bold">{l.priorite?.rang ?? '—'}</td>
                  <td className="p-2">{l.nom}</td>
                  <td className="p-2 text-right" data-testid={`performance-realise-${l.installateur_id}`}>{fmt0(l.ca_realise)}</td>
                  <td className="p-2 text-right font-semibold" data-testid={`performance-pct-${l.installateur_id}`}>{l.pct} %</td>
                  <td className="p-2 text-right">{fmtArgent(l.rythme_hebdo)}</td>
                  <td className="p-2 text-right">{l.projection == null ? '—' : fmt0(l.projection)}</td>
                  <td className="p-2"><span className={`text-xs px-2 py-0.5 rounded-full border ${CLASSES_STATUT[l.statut]}`} data-testid={`performance-statut-${l.installateur_id}`}>{LIBELLES_STATUT[l.statut]}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </CardContent>
    </Card>
  );
}
